import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	Typography,
	useTheme,
	CircularProgress
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import React, { useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { showError, showSuccess } from '../../actions/misc/misc.actions'

const useStyles = makeStyles((theme) => ({
	close: {
		position: 'absolute',
		color: '#777679',
		top: 10,
		right: 10,
		padding: 10,
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		cursor: 'pointer'
	},
	descriptor: {
		fontSize: '16px',
		fontWeight: '550',

		'& i': {
			fontSize: '20px',
			marginLeft: '17px',
			marginRight: '8px',
			color: '#6B4AD6',
			lineHeight: '20px'
		}
	},
	descriptors: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap'
	},
	dialog: {
		'& .MuiDialog-paper': {
			width: 920,
			maxWidth: 1000
		}
	},
	dialogActions: {
		justifyContent: 'space-between',
		padding: '16px 24px',
		borderTop: '1px solid #D0CFD2'
	},
	formWrapper: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 20
	},
	friend: {
		display: 'flex',
		flexDirection: 'row',
		margin: 10
	},
	friendAvatar: {
		height: '38px'
	},
	friendName: {
		fontSize: '16px',
		fontWeight: '550',
		margin: '8px'
	},
	h6: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: 16,
		margin: 16
	},
	line: {
		marginTop: '8px',
		marginBottom: 8,
		height: 1,
		border: '1px solid #D0CFD2'
	},
	noteBody: {
		margin: 14,
		fontSize: 14,
		width: 424
	},
	petRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		width: '100%',
		'& img': {
			height: 50,
			width: 50,
			borderRadius: 25,
			marginRight: 15
		},
		'& h4': {
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16,
			padding: 16
		}
	},
	reportHeader: {
		marginBottom: 12,
		'& h2': {
			textTransform: 'uppercase',
			fontWeight: '800',
			fontSize: '16px !important'
		}
	},
	reportPreview: {
		//overflowY: "scroll",
		display: 'flex',
		flexDirection: 'row',
		paddingTop: 15
	},
	report: {
		display: 'flex',
		flexDirection: 'column'
	},
	reportItem: {
		minHeight: 100,
		height: 'auto',
		width: 500,
		background: '#F9F9F9',
		marginRight: 8,
		marginTop: 8,
		marginBottom: 8,
		borderRadius: '6px'
	},
	reportPictures: {
		marginLeft: 12,
		width: 350,
		minHeight: 396,
		height: 'auto',
		borderRadius: '6px',
		background: '#F9F9F9',
		display: 'flex',
		flexDirection: 'column'
	},
	pictureHolder: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		display: 'flex',
		margin: 12,
		marginTop: 0
	},
	picture: {
		width: 155,
		height: 155,
		margin: 4,
		border: '1px solid #D0CFD2',
		borderRadius: '10px'
	},
	visitorContainer: {
		// border: "1px solid black",
		display: 'flex',
		flexDirection: 'column',
		paddingBottom: '24'
	},
	visitor: {
		marginBottom: '16px',
		// height: "88px",
		//border: "1px solid red",
		background: '#F9F9F9',
		borderRadius: '6px',
		display: 'flex',
		flexDirection: 'row',
		overflow: 'hidden'
	},
	visitorImage: {
		width: '88px',
		height: '88px'
	},
	visitorPicture: {
		width: '88px',
		height: '88px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '6px 0px 0px 0px',
		overflow: 'hidden',
		backgroundColor: '#BBBDF9'
		// border: "1px solid black"
	},
	visitorPictureGuest: {
		width: '88px',
		height: '88px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		borderRadius: '6px 0px 0px 6px',
		overflow: 'hidden',
		backgroundColor: '#BBBDF9'
		// border: "1px solid black"
	},
	guestText: {
		fontSize: 16,
		fontWeight: '800',
		color: '#FFFFFF'
	},
	pic: {
		height: '100%',
		width: '100%'
	},
	vistorDetails: {
		height: 88,
		// margin: "16px",
		paddingLeft: 16,
		paddingRight: 16,
		width: 'auto',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: 250,
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},
	visitorEligibility: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		paddingTop: 8,
		width: '50%'
	},
	codeInstructions: {
		padding: 16
	},
	eligibilityText: {
		color: '#777679',
		fontSize: 14,
		fontWeight: '700',
		textAlign: 'center'
		// letterSpacing: 0.75,
		// textTransform: 'uppercase'
	},
	vistorName: {
		display: 'flex',
		alignItems: 'center',
		paddingTop: '0px'
	},
	vistorRemove: {
		display: 'flex',
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		paddingRight: 16,
		alignItems: 'flex-start',
		paddingTop: '24px'
	},
	vistorSubtitle: {
		paddingTop: '0px',
		color: '#777679',
		fontSize: '14px',
		fontWeight: '600'
	},
	chargeForm: {
		width: '100%',
		height: 200
	},
	chargeType: {
		width: '100%'
	},
	grid: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		width: '60%'
	},
	receipt: {
		width: '40%',
		// flex: 0.4,
		paddingLeft: 16,
		paddingRight: 16
	},
	col1: {
		width: '55%'
	},
	col2: {
		width: '20%'
	},
	col3: {
		width: '25%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end'
	},
	chip: {
		'& > span': { marginRight: '0px' }
	},
	addedWrapper: {
		position: 'relative',
		height: 44,
		width: '100%',
		'&:before': {
			content: '""',
			position: 'absolute',
			top: 13,
			left: 0,
			width: '100%',
			height: 1,
			background: '#6B4AD6'
		}
	},
	addedText: {
		position: 'absolute',
		top: 2,
		right: 0,
		margin: 0,
		paddingLeft: 8,
		fontFamily: 'Nunito',
		fontWeight: '600',
		fontSize: '16px',
		lineHeight: '22px',
		color: '#6B4AD6',
		background: '#FFFFFF'
	},
	codeInt: {
		display: 'flex',
		flexDirection: 'row',
		backgroundColor: '#F9F9F9',
		justifyContent: 'center',
		alignItems: 'center',
		padding: 24
	}
}))

export const Parking = ({ checkIn, getCode, setCodeOnCheckIn, parking_codes, validMemberships }) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [codes, setCodes] = useState([])
	const [showModal, setShowModal] = useState(false)
	const [selectedCode, setSelectedCode] = useState(null)
	const [codeLoading, setCodeLoading] = useState(false)

	useEffect(() => {
		if (parking_codes) {
			let validCodes = parking_codes?.filter((c) => !c.used) || []
			let usedCode = parking_codes?.find((c) => c.checkin_id == checkIn._id)
			setSelectedCode(usedCode || null)
			setCodes(validCodes)
			if (usedCode) setCodeOnCheckIn(usedCode)
		}
	}, [parking_codes, checkIn])

	const refreshCodes = async () => {
		try {
			setCodeLoading(true)
			const code = await getCode(checkIn._id)
			if (code) {
				setSelectedCode(code)
				setShowModal(true)
				setCodeOnCheckIn(code)
			} else {
				dispatch(showError('No codes available'))
			}
			setCodeLoading(false)
		} catch (e) {
			// setShowModal(true)
			setCodeLoading(false)
			dispatch(showError('Error getting code'))
			console.log('bad one down here....', e)
		}
	}

	const vips = ['vip_annual', 'vip_monthly', 'founding']

	const isVip = validMemberships?.some((m) => vips.includes(m.type))

	if (!isVip) return null

	return (
		<div>
			<div>
				<Typography
					className={classes.reportHeader}
					style={{
						fontSize: 16,
						fontWeight: '800',
						textTransform: 'capitalize',
						marginBottom: 16,
						marginRight: 12,
						marginTop: 16
					}}>
					Parking
				</Typography>
			</div>
			<div style={{ display: 'flex', justifyContent: 'space-between', width: '58%', alignItems: 'center' }}>
				{selectedCode ? (
					<div className={classes.codeInt} style={{ padding: 12 }}>
						<Typography style={{ fontSize: 16, fontWeight: '600', color: 'black', letterSpacing: 2 }}>
							{selectedCode?.code || ''}
						</Typography>
					</div>
				) : (
					<Button
						variant="text"
						disabled={!codes.length}
						onClick={() => {
							refreshCodes()
							// setShowModal(true)
						}}
						endIcon={
							codeLoading ? (
								<CircularProgress />
							) : (
								<i
									className="far fa-window-restore"
									style={{ color: '#6B4AD6', marginLeft: '8px' }}
								/>
							)
						}
						style={{
							color: '#6B4AD6',
							paddingLeft: 0,
							marginBottom: 10,
							fontSize: 14,
							fontWeight: '800',
							opacity: codes.length ? 1 : 0.5
						}}>
						GET PARKING VALIDATION CODE
					</Button>
				)}
			</div>
			<ParkingModal
				isShown={showModal}
				setShowModal={setShowModal}
				code={selectedCode}
				codeLoading={codeLoading}
			/>
		</div>
	)
}

const ParkingModal = ({ isShown, setShowModal, code, codeLoading }) => {
	const classes = useStyles()

	const getCodeText = () => {
		if (codeLoading) return <CircularProgress />
		if (!code && !codeLoading)
			return (
				<Typography style={{ fontSize: 24, fontWeight: '600', color: 'red', letterSpacing: 2 }}>
					No code available
				</Typography>
			)

		return (
			<Typography style={{ fontSize: 24, fontWeight: '600', color: 'black', letterSpacing: 2 }}>
				{code?.code || ''}
			</Typography>
		)
	}

	return (
		<Dialog
			open={isShown}
			className={classes.dialog}
			onClose={() => setShowModal(false)}
			PaperProps={{
				style: {
					width: 500,
					maxWidth: 500,
					minHeight: 300,
					maxHeight: 300,
					padding: 0
				}
			}}>
			<div style={{ width: '100%' }}>
				<div style={{ padding: '24px' }}>
					<DialogTitle className={classes.reportHeader} style={{ marginBottom: 0 }}>
						PARKING VALIDATION CODE
					</DialogTitle>
					<span className={classes.close} onClick={() => setShowModal(false)}>
						X
					</span>
				</div>
			</div>
			<DialogContent style={{ padding: '24px' }}>
				<div className={classes.code}>
					<div className={classes.codeInt}>{getCodeText()}</div>
					<div className={classes.codeInstructions}>
						<Typography className={classes.eligibilityText}>
							Please write this code on a card for the customer. The code is single-use only and must
							be used today.
						</Typography>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	)
}
